(() => {
  if (window.customFestivalFormValidationLoaded) return;
  window.customFestivalFormValidationLoaded = true;

  const formSelector = [
    '.custom-contact__form',
    '.custom-homepage-plan-visit__form',
    '.custom-rsvp-section__form',
  ].join(',');

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const clearValidationMessage = (event) => {
    const field = event.target;
    if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) {
      field.setCustomValidity('');
    }
  };

  const validateForm = (form) => {
    const fields = form.querySelectorAll('input:not([type="hidden"]), textarea, select');

    fields.forEach((field) => {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;

      field.setCustomValidity('');

      if (field.type !== 'password') {
        field.value = field.value.trim();
      }

      if (field.required && field.value === '') {
        field.setCustomValidity('Please complete this required field.');
        return;
      }

      if (field.type === 'email' && field.value !== '' && !emailPattern.test(field.value)) {
        field.setCustomValidity('Please enter a valid email address.');
      }
    });

    return form.checkValidity();
  };

  document.addEventListener('input', clearValidationMessage);

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;

      if (!validateForm(form)) {
        event.preventDefault();
        form.reportValidity();
      }
    },
    true
  );
})();
